<p-avatar-group>
  @for (avatar of displayedAvatars(); track avatar) {

    @let img = avatar.avatarUrl | bearerImage | async;
    <elcia-tooltip [tooltip]="avatar.fullName!">

      <p-avatar [image]="img ?? undefined"
                [label]="img ? '' : (avatar.initials || '')"
                [size]="this.size()"
                shape="circle"/>

    </elcia-tooltip>
  }
  @if (remainingCount() > 0) {
    <span pTooltip="{{allFullNames()}}">
      <p-avatar [label]="'+' + remainingCount()" [size]="this.size()" shape="circle"/>
    </span>
  }
</p-avatar-group>
